module.exports = __webpack_public_path__ + "static/img/item-three-video.cfa6fae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/library/item-three-video.png
// module id = RTxk
// module chunks = 2